//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { ITwitterUser } from '@apis/twitter-analytics/twitterAnalyticsApiModel';
import {
  IGetTwitterUserResponse,
  IGetUserRequest,
} from '@apis/twitter-user/twitterUserApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const TWITTER_DEFAULT_ENDPOINT = '/api/v1/user';

const twitterGatewayUserFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'twitter_gateway',
    `${TWITTER_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

/**
 * Gets the client's Twitter user
 *
 * GET /api/v1/user
 */
export const getUser = async (
  req: IGetUserRequest,
  init?: RequestInit,
): Promise<ITwitterUser | undefined> => {
  const params = makeParams(req);
  const res = await twitterGatewayUserFetch(`?${params}`, init);

  return (await res.json<IGetTwitterUserResponse>()).data;
};
